<template>
    <div class="menu">
        <!-- TOP -->
        <div class="top" ref="top">
            <div class="name-icon">
                <router-link tag="h1" to="/">
                    Sebastian Báez
                </router-link>
                <div @click="toggleShowMenu()" class="menu-icon" ref="menu_icon" title="Menú">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <router-link :to="{ name: 'home', hash: `#${hash_back}` }" v-if="!show_menu && current_route != 'home'">
                <img :src="require(`@/assets/images/${url_arrow_return}`)" class="arrow-return" title="Inicio" alt="back">
            </router-link>
        </div>
        <!-- LINKS -->
        <transition name="top-bottom-animation">
            <div v-show="show_menu" class="container-full-menu">
                <!-- STARS -->
                <stars></stars>
                <ul>
                    <li>
                        <router-link tag="a" :to="{ name: 'home' } " @click.native="toggleShowMenu()">
                            <span class="animate-line"></span>
                            INICIO
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="a" :to="{ name: 'about-me' } " @click.native="toggleShowMenu()">
                            <span class="animate-line"></span>
                            SOBRE MI
                        </router-link>
                    </li>
                    <li>
                        <router-link tag="a" :to="{ name: 'works' } " @click.native="toggleShowMenu()">
                            <span class="animate-line"></span>
                            MIS TRABAJOS
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            v-if="current_route != 'home'"
                             tag="a" :to="{ path: '/', hash: '#contacto' } " @click.native="toggleShowMenu()">
                            <span class="animate-line"></span>
                            CONTACTO
                        </router-link>
                        <a 
                            v-else
                            href="/portafolio/#contacto" @click="toggleShowMenu()">
                            <span class="animate-line"></span>
                            CONTACTO
                        </a>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import StarsComponent from '@/components/StarsComponent'

export default {
    components: {
        'stars': StarsComponent
    },
    data() {
        return {
            show_menu: false,
            current_route: '',
            hash_back: 'perfil',
            url_arrow_return: 'svg-icons/arrow-left-white.svg'
        }
    },
    mounted() {
        
    },
    methods: {
        toggleShowMenu() {
            this.show_menu = !this.show_menu;
            this.changeColors();
        },
        setRoute() {
            this.current_route = this.$route.name;
            if (this.current_route == 'about-me') {
                this.hash_back = 'sobre-mi';
            } else if (this.current_route == 'works') {
                this.hash_back = 'trabajos';
            } else {
                this.hash_back = 'perfil';
            }
        },
        changeColors() {
            let title = this.$refs.top.firstChild.firstChild,
                menu_icon = this.$refs.menu_icon;

            if (window.scrollY >= (screen.height - 200) && !this.show_menu) {
                title.style.color = '#000000';
                this.url_arrow_return = 'svg-icons/arrow-left-black.svg';
                menu_icon.classList.add('menu-icon-black');
            } else {
                title.style.color = '#FFFFFF';
                this.url_arrow_return = 'svg-icons/arrow-left-white.svg';
                menu_icon.classList.remove('menu-icon-black');
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.changeColors);
    },
    computed: {
        window_height() {
            return screen.height
        }
    },
    watch: {
        '$route': 'setRoute'
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.menu {    
    // TOP
    .top {
        position: fixed;
        width: 100%;
        top: 0;
        padding: 20px 20px 0px 20px;
        z-index: 22;

        .name-icon {
            display: flex;
            align-items: center;
            justify-content: space-between;

            h1 {
                font-family: $Futura-Light;
                color: #FFFFFF;
                font-size: 1.1rem;
                cursor: pointer;
                transition: all 0.5s;

                &:hover { opacity: 0.7 }
            }
            .menu-icon-black { span { background-color: #000000 !important } }
            .menu-icon {
                width: 27px;
                height: 15px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                cursor: pointer;
                transition: all 0.5s;
                &:hover { opacity: 0.7 }

                span { 
                    transition: all 0.5s;
                    width: 100%;
                    height: 3px;
                    background-color: #FFFFFF;
                    margin-bottom: 5px;
                    &:last-child { margin-bottom: 0px }
                }
            }

        }
        // Arrow Return
        .arrow-return {
            width: 35px;
            margin-top: 25px;
            animation: arrow-return 1s;
            transition: all 0.5s;

            &:hover {
                @include transform(translate(-10px))
            }
        }

        @keyframes arrow-return {
            from { margin-left: 45px }
            to { margin-left: 0px }
        }

        @media (min-width: 760px) {
            padding: 35px 35px 0px 35px;

            .name-icon {
                h1 { font-size: 1.4rem }
                .menu-icon {
                    width: 50px;
                    height: 23px
                }
            }

            // Arrow Return
            .arrow-return {
                width: 55px;
                margin-top: 25px
            }
        }
    }

    // LINKS
    .container-full-menu {
        background-color: #000000;
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100%;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: center;

        ul {
            margin: 0px;
            list-style: none;
            text-align: center;
            font-size: 2rem;

            li { 
                margin-bottom: 25px;
                position: relative;

                a {
                    position: relative;
                    color: #FFFFFF;
                    text-decoration: none;

                    &:hover {
                        .animate-line {
                            animation: text-line 0.5s forwards
                        }
                    }

                    .animate-line {
                        background-color: #FFFFFF;
                        width: 0%;
                        height: 3px;
                        position: absolute;
                        left: -2%;
                        top: 50%;
                    }
                }
            }

            @media (min-width: 760px) {
                font-size: 4rem;
                li { 
                    margin-bottom: 55px;
                    a {
                        .animate-line { height: 5px }
                    }
                }
            }

            @media (min-width: 1024px) { margin-top: 7% }
            @media (min-width: 1600px) { 
                font-size: 6rem;
                li { 
                    margin-bottom: 70px;
                    a {
                        .animate-line { height: 9px }
                    }
                }
            }
        }
    }

    // ANIMATIONS
    @keyframes text-line {
        from { width: 0 }
        to { width: 104% }
    }

    .top-bottom-animation-enter-active { transition: all 0.5s ease } 
    .top-bottom-animation-leave-active {
        top: 100%;
        transition: all 0.5s ease;
    }
    .top-bottom-animation-enter { top: -100% }
}
</style>